import { render, staticRenderFns } from "./EventListItem.vue?vue&type=template&id=f2941ac6&scoped=true&"
import script from "./EventListItem.vue?vue&type=script&lang=js&"
export * from "./EventListItem.vue?vue&type=script&lang=js&"
import style0 from "./EventListItem.vue?vue&type=style&index=0&id=f2941ac6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2941ac6",
  null
  
)

export default component.exports